// extracted by mini-css-extract-plugin
export default {"checkIconWrapper":"style_checkIconWrapper__Q04kT","loader":"style_loader__L4tZ-","spinner":"style_spinner__KMCVJ","spin":"style_spin__sRgTp","text":"style_text__Bwc7B"};